import styled from "styled-components";

export const Main = styled.div`
   min-width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   .empty {
      margin-top: 20px;
      text-align: center;
      font-size: 14px;
      color: #ff0000;
      opacity: 0.75;
      line-height: 1.3;
   }
`;